import {useEffect, useState} from 'react';
import qs from 'query-string';

/**
 * 外部（App / WebView）打开页面时的查询参数。
 * 同时兼容：
 * - /collectionSynthesis/home?cl=藏品ID&ac=活动码&t=token
 * - /xxx/index.html?t=token#/collectionSynthesis/home?cl=xx&ac=xx
 */
export const parseExternalQuery = (routerSearch = '') => {
  const hash = window.location.hash || '';
  const hashSearch = hash.includes('?') ? hash.slice(hash.indexOf('?')) : '';
  return {
    ...qs.parse(window.location.search),
    ...qs.parse(hashSearch),
    ...qs.parse(routerSearch || ''),
  };
};

const pickQueryValue = (value) => {
  if (Array.isArray(value)) return value[0] || '';
  return value || '';
};

export const getCollectionIdFromQuery = (query = {}) => (
  pickQueryValue(query.cl || query.collectionId || query.collection_id || query.collectionID)
);

export const getActivityCodeFromQuery = (query = {}) => (
  pickQueryValue(query.ac || query.activityCode)
);

const getRemainCount = (data = {}) => {
  const limitType = Number(data.limitType);
  const single = data.singleRemainCount;
  const total = data.totalRemainCount;
  if (limitType === 0) return null;
  if (limitType === 1) return single;
  if (limitType === 2) return total;
  if (limitType === 3) {
    const a = Number(single);
    const b = Number(total);
    if (Number.isNaN(a)) return total;
    if (Number.isNaN(b)) return single;
    return Math.min(a, b);
  }
  return single ?? total ?? '';
};

/** 0 随机材料模式  1 固定材料模式 */
export const COMPOSE_MODE_RANDOM = 0;
export const COMPOSE_MODE_FIXED = 1;

const getMaterialMode = (data = {}) => {
  const raw = data.materialMode;
  if (raw === '' || raw == null) return '';
  const n = Number(raw);
  if (n === COMPOSE_MODE_FIXED) return COMPOSE_MODE_FIXED;
  if (n === COMPOSE_MODE_RANDOM) return COMPOSE_MODE_RANDOM;
  return '';
};

const getRandomCount = (data = {}) => {
  const raw = data.randomCount;
  if (raw === '' || raw == null) return '';
  const n = Number(raw);
  return Number.isNaN(n) ? '' : n;
};

const getMaterialRequiredQuantity = (item = {}) => {
  const raw = item.requiredQuantity;
  if (raw === '' || raw == null) return '';
  const n = Number(raw);
  return Number.isNaN(n) ? '' : n;
};

export const formatReservedCount = (value) => {
  if (value === '' || value == null) return 'x';
  const n = Number(value);
  return Number.isNaN(n) ? 'x' : n;
};

export const mapComposeInit = (data = {}) => {
  const materialList = data.materialList || data.synthesizeInitVOS || [];
  const slots = materialList.slice(0, 8).map((item, index) => ({
    slotKey: `${item.collectionId || 'slot'}_${index}`,
    collectionId: item.collectionId,
    imageBg: item.nftImage || item.imageBg || '',
    name: item.collectionName || item.name || `材料${index + 1}`,
    requiredQuantity: getMaterialRequiredQuantity(item),
  }));
  return {
    slots,
    owningGroup: data.owningGroup || '',
    maxCount: getRemainCount(data),
    resultQuantity: data.resultQuantity,
    limitType: data.limitType,
    collectionId: data.collectionId || '',
    materialMode: getMaterialMode(data),
    randomCount: getRandomCount(data),
  };
};

export const useStatusBarInset = () => {
  const [inset, setInset] = useState(0);
  useEffect(() => {
    if (window.JsBridge?.hasWebViewBridge?.()) {
      window.JsBridge.getStatusBarHeight().then(({height}) => {
        setInset(Number(height) || 0);
      });
    }
  }, []);
  return inset;
};
